import { Container, SectionHead } from './WebinarShared';

const WebinarBenefits = ({ eyebrow, heading, intro, items }) => {
  return (
    <section className="bg-white py-16 md:py-[88px]">
      <Container>
        <SectionHead eyebrow={eyebrow} heading={heading} intro={intro} />
        {/* Column-major 2-up grid: rows adapt to the item count so any number of
            benefits (8, 10, odd counts…) splits into two balanced columns. */}
        <div
          className="grid grid-cols-1 gap-x-14 gap-y-8 md:grid-flow-col md:grid-cols-2 md:gap-y-9 md:[grid-template-rows:repeat(var(--benefit-rows),auto)]"
          style={{ '--benefit-rows': Math.ceil((items?.length || 0) / 2) }}
        >
          {items?.map((item, i) => (
            <div key={item.id} className="flex items-start gap-[18px]">
              <div className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[9px] bg-brand-400 text-[15px] font-semibold text-white">
                {i + 1}
              </div>
              <div>
                {item.title && <h3 className="mb-1 font-sans text-base font-semibold text-grey-950">{item.title}</h3>}
                {item.text && <p className="text-[15px] leading-[1.55] text-grey-500">{item.text}</p>}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WebinarBenefits;
